function CategoryFactory() {
    const categories = [
        'Wine Almighty',
        'Tipsy Adventure',
        'Tradition of Supra',
        'Colorful Cuisine',
        'History',
        'Culture',
        'Architecture',
        'Tbilisi',
        'Highlands',
        'Ski Resorts',
        'Black Sea',
        'Nature',
        'Adventure'
    ]
    let selectedCategories = []

    const getCategories = () => categories

    const getSelectedCategories = () => selectedCategories

    const setSelectedCategories = (data) => {
        selectedCategories = JSON.parse(JSON.stringify(data))

        sessionStorage.setItem('tourists_categories', JSON.stringify(data))
    }

    const clearSelectedCategories = () => {
        sessionStorage.setItem('tourists_categories', JSON.stringify([]))
        selectedCategories = []
    }

    return {
        getCategories,
        getSelectedCategories,
        setSelectedCategories,
        clearSelectedCategories
    }
}

export default CategoryFactory



// WEBPACK FOOTER //
// ./client/app/components/home/sidebar/categories/categories.factory.js